export default {
	showDevScreens: true,
	useFixtures: false,
	ezLogin: false,
	yellowBox: true,
	reduxLogging: true,
	includeExamples: true,
	useReactotron: true
}
